import { deserialize } from 'cerialize'
import { ProductHeaderFieldModel, ProductFieldModel } from 'Pages/orders'

export class ProductAvailableFieldModel {
	@deserialize public header?: ProductHeaderFieldModel
	@deserialize public fields?: ProductFieldModel[]
}
